
export const  useNav = ()=>{


  const List = ref<any>()
  

  const  setList = (value:any)=>{
          
         List.value = value
          
  }
   provide('navList',{
      List,
      setList
   })
}
  

export const  useLang = (app:any)=>{
      const langState = ref<any>(null)
      //console.log('11111111111','dddd')
      const  setLang=(value:any)=>{
            langState.value = value
       
     }
     app.provide('useLang',{
      langState,
      setLang
     })
}

export const  useAvatar = (app:any)=>{


   const avatar = ref<any>(null)
   const setAvatar = (value:any)=>{
      avatar.value = value
   }
   app.provide('useAvatar',{
      avatar,
      setAvatar
   })
}